import "./Historypage.css";
import HistoryText from "../Components/HistoryText";

export default function History() {
  return (
    <div className="desktop-p-history-margin">
      <HistoryText />
    </div>
  );
}
